import { Type } from '@sinclair/typebox';
import { SupportedDexSchema } from '../supported-dex.js';
import { SupportedNetworkSchema } from '../supported-network.js';
import { PoolAuditSchema } from './pool-audit.js';
import { PoolTokenSchema } from './pool-token.js';
import { PoolExtraDetailsSchema, PoolModelAccountsSchema, PoolWalletGroupSchema, } from './pool.js';
export const PoolShortSchema = Type.Object({
    provider: SupportedDexSchema,
    network: SupportedNetworkSchema,
    address: Type.String(),
    base: PoolTokenSchema,
    quote: PoolTokenSchema,
    pair: Type.Tuple([Type.String(), Type.String()]),
    priceNative: Type.String({
        description: 'Price of the token in the native currency',
    }),
    priceUsd: Type.String(),
    marketCapUsd: Type.String(),
    liquidityUsd: Type.String(),
    liquidityNative: Type.String(),
    liquidityToken: Type.String(),
    poolFee: Type.Optional(Type.Number()),
    audit: PoolAuditSchema,
    holders: Type.Object({
        count: Type.String(),
        top10Holding: Type.String(),
    }),
    insiders: PoolWalletGroupSchema,
    snipers: PoolWalletGroupSchema,
    bundlers: PoolWalletGroupSchema,
    initTimestamp: Type.Optional(Type.String()),
    initBlock: Type.Optional(Type.Number()),
    initTxSignature: Type.Optional(Type.String()),
    initTxCreator: Type.Optional(Type.Object({
        address: Type.String(),
        balanceInToken: Type.Optional(Type.String()),
        buyVolumeInUsd: Type.Optional(Type.String()),
        sellVolumeInUsd: Type.Optional(Type.String()),
        buys: Type.Optional(Type.Number()),
        sells: Type.Optional(Type.Number()),
        lastTx: Type.Optional(Type.Object({
            at: Type.String(),
            amountInToken: Type.String(),
            amountInUsd: Type.String(),
            operation: Type.Union([Type.Literal('buy'), Type.Literal('sell')]),
        })),
    })),
    extraDetails: Type.Optional(PoolExtraDetailsSchema),
    accounts: Type.Optional(PoolModelAccountsSchema),
    updatedAt: Type.String(),
    infoUpdatedAt: Type.Optional(Type.String()),
    metricsUpdatedAt: Type.Optional(Type.String()),
    chartsUpdatedAt: Type.Optional(Type.String()),
}, {
    title: 'PairShortSchema',
});
//# sourceMappingURL=pool-short.js.map